<template>
  <div class="sidebar-container">
    <router-link tag="div" to="/index" class="logo-container">
      <img src="@/assets/logo.png" alt="" />
      <h4>管理系統</h4>
    </router-link>
    <el-scrollbar style="height: calc(100% - 60px); overflow-x: hidden">
      <el-menu router :default-active="$route.path">
        <template v-for="route in routes">
          <el-menu-item :index="route.path" :key="route.path" v-if="!route['children']">
            <svg-icon :icon-class="$route.path === route.path ? `${route.meta.icon}-active` : route.meta.icon" class="icon"></svg-icon>
            <span slot="title">{{ route.meta.title }}</span>
          </el-menu-item>
          <template v-else>
            <el-submenu :index="route.path" :key="route.path">
              <template slot="title">
                <svg-icon :icon-class="$route.path === route.path ? `${route.meta.icon}-active` : route.meta.icon" class="icon"></svg-icon>
                <span>{{ route.meta.title }}</span>
              </template>
              <el-menu-item v-for="child in route.children" :key="child.path" :index="child.path">
                <svg-icon :icon-class="child.meta.icon" class="icon"></svg-icon>
                <span slot="title">{{ child.meta.title }}</span>
              </el-menu-item>
            </el-submenu>
          </template>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  computed: {
    routes() {
      const userInfo = this.$getCache('crm_user')
      if (userInfo) {
        const userLevel = userInfo?.userLevel
        const role = userLevel == 0 ? 'admin' : 'staff'
        const layoutRoute = this.$router.options.routes.filter((route) => route.children && route.children.length > 0)[0]
        if (!layoutRoute) return []
        return layoutRoute.children
          .filter((route) => !route.hidden)
          .filter((route) => {
            if (!route.meta || !route.meta.roles) return true
            return route.meta.roles.includes(role)
          })
      } else {
        return this.$router.options.routes.filter((route) => route.children && route.children.length > 0)[0].children.filter((route) => !route.hidden)
      }
    }
  }
}
</script>

<style scoped lang="less">
.sidebar-container {
  .logo-container {
    height: 52px;
    box-sizing: border-box;
    padding: 40px 16px 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    h4 {
      height: 16px;
    }
    img {
      width: 80px;
      height: 26px;
    }
  }
  .icon {
    font-size: 24px;
    vertical-align: middle;
  }
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
}
</style>
